(() => {
  let chain = Promise.resolve();
  let lastFocus;
  let toastTimer;
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const root = () => (window.Shopify?.routes?.root || drawer()?.dataset.root || '/');
  const text = (key) => drawer()?.dataset[key] || '';
  const enqueue = (task) => { chain = chain.then(task, task); return chain; };
  const status = (message) => { const el = drawer()?.querySelector('[data-cart-status]'); if (el) el.textContent = message; };
  const formatMoney = (cents, currency) => new Intl.NumberFormat('es-GT', { style: 'currency', currency: currency || 'GTQ' }).format(cents / 100);
  const make = (tag, className, value) => { const el = document.createElement(tag); if (className) el.className = className; if (value !== undefined) el.textContent = value; return el; };
  const toast = (message) => {
    const el = document.querySelector('[data-cart-toast]');
    if (!el) return;
    clearTimeout(toastTimer); el.textContent = message; el.hidden = false; el.classList.add('show');
    toastTimer = setTimeout(() => { el.classList.remove('show'); el.hidden = true; }, 3500);
  };
  const render = (cart, focusKey, focusAction) => {
    const dialog = drawer(); if (!dialog) return;
    const content = dialog.querySelector('[data-cart-content]');
    const fragment = document.createDocumentFragment();
    if (!cart.items.length) fragment.append(make('p', 'hype-cart-empty', text('empty')));
    cart.items.forEach((item) => {
      const article = make('article', 'hype-cart-item');
      article.dataset.cartKey = item.key;
      if (item.image) { const img = make('img'); img.src = item.image; img.alt = item.product_title; img.width = 80; img.height = 80; article.append(img); }
      else article.append(make('div'));
      const info = make('div');
      const link = make('a', '', item.product_title); link.href = item.url; info.append(link);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(make('p', '', item.variant_title));
      if (item.selling_plan_allocation?.selling_plan?.name) info.append(make('p', '', item.selling_plan_allocation.selling_plan.name));
      const price = make('strong', 'hype-cart-line-price', formatMoney(item.final_line_price, cart.currency)); info.append(price);
      const controls = make('div', 'hype-cart-controls');
      const qty = make('div', 'hype-cart-qty');
      ['minus', 'plus'].forEach((action, index) => {
        const button = make('button', '', index ? '+' : '−'); button.type = 'button'; button.dataset.cartChange = action;
        button.dataset.key = item.key; button.dataset.quantity = String(item.quantity + (index ? 1 : -1));
        button.setAttribute('aria-label', `${text('quantity')} ${index ? '+' : '−'}: ${item.product_title}`);
        qty.append(button);
        if (!index) qty.append(make('span', '', String(item.quantity)));
      });
      const remove = make('button', 'hype-cart-remove', text('remove')); remove.type = 'button'; remove.dataset.cartChange = 'remove'; remove.dataset.key = item.key; remove.dataset.quantity = '0'; remove.setAttribute('aria-label', `${text('remove')}: ${item.product_title}`);
      controls.append(qty, remove); info.append(controls); article.append(info); fragment.append(article);
    });
    content.replaceChildren(fragment);
    dialog.querySelector('[data-cart-subtotal]').textContent = formatMoney(cart.total_price, cart.currency);
    dialog.querySelector('[data-cart-bottom]').hidden = !cart.items.length;
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    status('');
    if (focusKey && dialog.open) {
      const target = Array.from(dialog.querySelectorAll('[data-cart-change]')).find(el => el.dataset.key === focusKey && el.dataset.cartChange === focusAction);
      (target || dialog.querySelector('[data-cart-close]')).focus();
    }
  };
  const readCart = async () => {
    const response = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(text('error'));
    return response.json();
  };
  const close = () => { const dialog = drawer(); if (!dialog?.open) return; dialog.close(); if (lastFocus?.isConnected) lastFocus.focus(); };
  const open = () => {
    const dialog = drawer(); if (!dialog) return;
    lastFocus = document.activeElement;
    if (!dialog.open) dialog.showModal();
    status(text('loading'));
    enqueue(async () => { try { render(await readCart()); } catch { status(text('error')); } });
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener && drawer()) { event.preventDefault(); open(); return; }
    if (event.target.closest('[data-cart-close]')) { close(); return; }
    const dialog = drawer();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      return;
    }
    const button = event.target.closest('[data-cart-change]');
    if (!button || !dialog) return;
    const key = button.dataset.key, quantity = Number(button.dataset.quantity), action = button.dataset.cartChange;
    dialog.querySelectorAll('[data-cart-change]').forEach(el => { el.disabled = true; });
    status(text('loading'));
    enqueue(async () => {
      try {
        const response = await fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : text('error'));
        render(result, key, action);
      } catch (error) {
        try { render(await readCart(), key, action); } catch {}
        status(error.message || text('error'));
      } finally { dialog.querySelectorAll('[data-cart-change]').forEach(el => { el.disabled = false; }); }
    });
  });
  document.addEventListener('cancel', (event) => { if (event.target === drawer()) { event.preventDefault(); close(); } }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !drawer()) return;
    const path = new URL(form.action, location.origin).pathname.replace(/\/$/, '');
    if (!path.endsWith('/cart/add')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.cartPending === 'true') return;
    form.dataset.cartPending = 'true';
    const button = event.submitter || form.querySelector('[type="submit"]');
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = window.HypeTexts?.cartAdding || text('loading'); }
    const data = new FormData(form); data.delete('return_to');
    enqueue(async () => {
      let accepted = false;
      try {
        const response = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : text('error'));
        accepted = true;
        render(await readCart());
        toast(text('added'));
      } catch (error) {
        if (accepted || error instanceof TypeError) {
          try { render(await readCart()); } catch {}
          toast(text('unknown'));
        } else toast(error.message || text('error'));
      } finally { form.dataset.cartPending = 'false'; if (button) { button.disabled = false; button.textContent = original; } }
    });
  }, true);
})();
